import React, { useState, useEffect, useRef } from "react";
import "./domain.css";

import Retail1 from "../Assets/retail1.png";
import Box1 from "../Assets/retail-box-1.png";
import Box2 from "../Assets/retail-box-2.png";
import Box3 from "../Assets/retail-box-3.png";
import Box4 from "../Assets/retail-box-4.png";

import { useStateContext } from "../contexts/ContextProvider";
import DomainBanner from "./DomainBanner";

const Retail = () => {
  const title = "Retail";
  const body =
    "In the dynamic world of retail, where tradition meets innovation and customer experience is everything, keeping your team ahead of the curve is crucial. Embracing modern training methods like e-training might seem like a big step, but it could be the game-changer your team needs. More than just a trend, e-training is a powerful tool to equip your workforce for success. Ready to transform the way you train? Let’s dive in!";

  const { handleShowContact } = useStateContext();

  const [play, setPlay] = useState(false);

  const vidRef = useRef(null);

  const handlePlay = () => {
    setPlay(true);
    if (vidRef && vidRef.current) {
      if (vidRef.current.paused) {
        setPlay(true);
        vidRef.current.play();
      } else {
        setPlay(false);
        vidRef.current.pause();
      }
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional, for animated scrolling
    });
  }, []);
  return (
    <>
      <DomainBanner domain="retail" title={title} body={body} />

      <div className="domain-section">
        <div className="domain-container domain-text domain-text-retail">
          <h3>Challenges Addressed by eTraining in Retail Industry</h3>
        </div>
      </div>

      <div className="domain-section">
        <div className="domain-container">
          <div className="domain-features retail">
            <div className="row">
              <div className="col-lg-4">
                <div className="box-new-3 box1">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box1} className="img-fluid" alt="" />
                      <div className="overlay-box2"></div>
                      <div className="overlay-content">
                        <h3><span>High Employee</span> Turnover</h3>
                      </div>
                    </div>
                    <div className="content">
                      <h3>High Employee Turnover</h3>
                      <p>
                        The retail industry often faces high turnover rates due
                        to factors such as seasonal demand, temporary
                        employment, and career mobility.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="box-new-3 box2">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box2} className="img-fluid" alt="" />
                      <div className="overlay-box2"></div>
                      <div className="overlay-content">
                        <h3><span>Product Knowledge &</span> Sales Skills</h3>
                      </div>
                    </div>
                    <div className="content">
                      <h3>Product Knowledge & Sales Skills</h3>
                      <p>
                        In afast-paced retail environment, employees need to
                        possess comprehensive product knowledge and effective
                        sales techniques to meet customer needs and drive sales.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 empty"></div>
              <div className="col-lg-4 empty"></div>
              <div className="col-lg-4">
                <div className="box-new-3 box3">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box3} className="img-fluid" alt="" />
                      <div className="overlay-box2"></div>
                      <div className="overlay-content">
                        <h3><span>Customer Experience &</span> Service Quality</h3>
                      </div>
                    </div>
                    <div className="content">
                      <h3>Customer Experience & Service Quality</h3>
                      <p>
                        Providing exceptional customer service is paramount in
                        the retail industry to build brand loyalty and drive
                        repeat business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="box-new-3 box4">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box4} className="img-fluid" alt="" />
                      <div className="overlay-box2"></div>
                      <div className="overlay-content">
                        <h3><span>Performance Tracking &</span> Analysis</h3>
                      </div>
                    </div>
                    <div className="content">
                      <h3>Performance Tracking & Analysis</h3>
                      <p>
                        Monitoring employee performance and assessing the
                        effectiveness of training initiatives are critical for
                        identifying areas of improvement and optimizing resource
                        allocation.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="domain-section">
        <div className="domain-container">
          <div className="domain-features2">
            <div className="domain-text">
              <h3>Investing in <span>eTraining</span> for Retail Training</h3>
              <p>
                By investing in eTraining, retail organizations can empower
                their staff to:
              </p>
            </div>
            <div className="domain-text">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-6">
                  <div className="domain-text-flex">
                    <span className="icon">
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 60 61"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M44.3008 28.1248C44.3008 20.2133 37.8929 13.7998 29.9883 13.7998C22.0837 13.7998 15.6758 20.2133 15.6758 28.1248V37.6498C15.6758 45.5613 22.0837 51.9748 29.9883 51.9748C37.8929 51.9748 44.3008 45.5613 44.3008 37.6498V28.1248Z"
                          stroke="#05A9A6"
                          strokeWidth="4.775"
                          strokeMiterlimit="10"
                        />
                        <path
                          d="M44.3242 23.3501H49.0992C50.9955 23.3501 52.8141 24.1034 54.155 25.4443C55.4959 26.7852 56.2492 28.6038 56.2492 30.5001V35.2751C56.2492 37.1714 55.4959 38.99 54.155 40.3309C52.8141 41.6718 50.9955 42.4251 49.0992 42.4251H44.3242V23.3501Z"
                          stroke="#05A9A6"
                          strokeWidth="4.775"
                          strokeMiterlimit="10"
                        />
                        <path
                          d="M15.6758 42.4248H10.9008C9.00448 42.4248 7.18585 41.6715 5.84497 40.3306C4.50408 38.9897 3.75078 37.1711 3.75078 35.2748L3.75078 30.4998C3.75078 29.5609 3.93572 28.6311 4.29504 27.7636C4.65436 26.8961 5.18103 26.1079 5.84497 25.444C6.50891 24.7801 7.29712 24.2534 8.16459 23.8941C9.03207 23.5347 9.96183 23.3498 10.9008 23.3498H15.6758L15.6758 42.4248Z"
                          stroke="#05A9A6"
                          strokeWidth="4.775"
                          strokeMiterlimit="10"
                        />
                        <path
                          d="M10.9004 23.35C10.9004 18.2844 12.9127 13.4262 16.4947 9.84426C20.0766 6.26232 24.9348 4.25 30.0004 4.25C35.066 4.25 39.9242 6.26232 43.5061 9.84426C47.0881 13.4262 49.1004 18.2844 49.1004 23.35"
                          stroke="#05A9A6"
                          strokeWidth="4.775"
                          strokeMiterlimit="10"
                        />
                        <path
                          d="M49.1004 42.4248V44.9248C49.0938 48.0898 47.8318 51.1229 45.5915 53.3586C43.3512 55.5942 40.3154 56.8498 37.1504 56.8498"
                          stroke="#05A9A6"
                          strokeWidth="4.775"
                          strokeMiterlimit="10"
                        />
                      </svg>
                    </span>
                    <span className="txt">Exceptional Customer Service</span>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-6">
                  <div className="domain-text-flex">
                    <span className="icon">
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 71 71"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M35.5004 31.0034V17.9572C35.5004 17.8095 35.4713 17.6634 35.4148 17.527C35.3583 17.3906 35.2755 17.2667 35.1711 17.1623C35.0668 17.0579 34.9428 16.9751 34.8064 16.9186C34.67 16.8621 34.5239 16.833 34.3762 16.833H29.9387C29.7925 16.833 29.6477 16.8622 29.5129 16.9191C29.3781 16.9759 29.2561 17.0592 29.1541 17.164C29.0521 17.2688 28.9721 17.393 28.9188 17.5292C28.8656 17.6654 28.8402 17.811 28.8441 17.9572V24.2584L31.8025 31.0034H35.5004Z"
                          fill="#05A9A6"
                        />
                        <path
                          d="M26.181 51.8004C25.0785 51.7945 23.9992 52.1165 23.08 52.7253C22.1609 53.3342 21.4435 54.2025 21.0189 55.22C20.5943 56.2374 20.4816 57.3581 20.6953 58.4397C20.9089 59.5213 21.4392 60.515 22.2188 61.2946C22.9984 62.0742 23.9921 62.6045 25.0737 62.8182C26.1553 63.0318 27.276 62.9192 28.2935 62.4946C29.311 62.07 30.1793 61.3526 30.7881 60.4334C31.397 59.5143 31.719 58.4349 31.7131 57.3324C31.7053 55.8676 31.12 54.465 30.0842 53.4293C29.0484 52.3935 27.6458 51.8081 26.181 51.8004ZM53.6344 51.8004C52.5319 51.7945 51.4525 52.1165 50.5334 52.7253C49.6143 53.3342 48.8968 54.2025 48.4722 55.22C48.0476 56.2374 47.935 57.3581 48.1486 58.4397C48.3623 59.5213 48.8926 60.515 49.6722 61.2946C50.4518 62.0742 51.4455 62.6045 52.5271 62.8182C53.6087 63.0318 54.7294 62.9192 55.7468 62.4946C56.7643 62.07 57.6326 61.3526 58.2415 60.4334C58.8503 59.5143 59.1723 58.4349 59.1665 57.3324C59.1665 55.8652 58.5836 54.4581 57.5461 53.4207C56.5087 52.3832 55.1016 51.8004 53.6344 51.8004ZM44.1381 14.9987C44.1381 14.7005 44.0197 14.4146 43.8089 14.2038C43.598 13.993 43.3121 13.8745 43.0139 13.8745H38.4581C38.3118 13.8745 38.167 13.9037 38.0323 13.9606C37.8975 14.0174 37.7755 14.1007 37.6735 14.2055C37.5714 14.3103 37.4914 14.4345 37.4382 14.5707C37.385 14.7069 37.3596 14.8525 37.3635 14.9987V31.0033H44.0198L44.1381 14.9987Z"
                          fill="#33D6D3"
                        />
                        <path
                          d="M30.441 37.6597L27.1869 44.3751H59.1665C59.7549 44.3751 60.3193 44.6089 60.7354 45.025C61.1514 45.4411 61.3852 46.0054 61.3852 46.5939C61.3852 47.1823 61.1514 47.7467 60.7354 48.1628C60.3193 48.5789 59.7549 48.8126 59.1665 48.8126H27.1869C26.4361 48.816 25.6969 48.6275 25.0394 48.2651C24.3819 47.9027 23.8278 47.3784 23.4298 46.7418C23.0223 46.1085 22.7863 45.3802 22.7448 44.6283C22.7033 43.8763 22.8578 43.1265 23.1931 42.4522L26.6248 35.5001L16.0931 12.5435H9.70312C9.11468 12.5435 8.55033 12.3097 8.13423 11.8936C7.71814 11.4775 7.48438 10.9132 7.48438 10.3247C7.48438 9.73626 7.71814 9.17191 8.13423 8.75581C8.55033 8.33972 9.11468 8.10596 9.70312 8.10596H17.5427C17.9674 8.10762 18.3828 8.23116 18.7394 8.46189C19.0959 8.69263 19.3788 9.02087 19.5544 9.40762L30.4706 33.2222H49.7885L59.3735 16.1526C59.5118 15.8917 59.7008 15.661 59.9294 15.474C60.158 15.2871 60.4216 15.1477 60.7048 15.0639C60.988 14.9802 61.285 14.9538 61.5785 14.9863C61.872 15.0189 62.1561 15.1097 62.414 15.2534C62.672 15.3972 62.8987 15.591 63.0808 15.8234C63.2629 16.0559 63.3967 16.3224 63.4745 16.6073C63.5522 16.8922 63.5723 17.1897 63.5336 17.4825C63.4949 17.7753 63.3981 18.0573 63.249 18.3122L53.6344 35.5001C53.2546 36.1882 52.6978 36.7622 52.0216 37.1627C51.3454 37.5632 50.5744 37.7757 49.7885 37.778L30.441 37.6597ZM52.806 23.3118V9.28929C52.8061 9.14302 52.7768 8.99823 52.72 8.86346C52.6631 8.7287 52.5799 8.60669 52.4751 8.50465C52.3703 8.40261 52.2461 8.32262 52.1098 8.26938C51.9736 8.21614 51.8281 8.19075 51.6819 8.19471H47.3331C47.1883 8.19062 47.0441 8.21615 46.9095 8.26971C46.7748 8.32327 46.6525 8.40375 46.5501 8.50622C46.4476 8.60868 46.3671 8.73098 46.3135 8.86563C46.26 9.00028 46.2345 9.14444 46.2385 9.28929V31.0035H48.5756L52.806 23.3118Z"
                          fill="#05A9A6"
                        />
                      </svg>
                    </span>
                    <span className="txt">Increased Retail Sales</span>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-12">
                  <div className="domain-text-flex">
                    <span className="icon">
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 60 61"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M44.0625 34.25C44.0625 37.9796 42.5809 41.5565 39.9437 44.1937C37.3065 46.8309 33.7296 48.3125 30 48.3125C26.2704 48.3125 22.6935 46.8309 20.0563 44.1937C17.4191 41.5565 15.9375 37.9796 15.9375 34.25"
                          fill="#7FEBE9"
                        />
                        <path
                          d="M39.375 34.25C39.375 36.7364 38.3873 39.121 36.6291 40.8791C34.871 42.6373 32.4864 43.625 30 43.625C27.5136 43.625 25.129 42.6373 23.3709 40.8791C21.6127 39.121 20.625 36.7364 20.625 34.25"
                          fill="#E7FF60"
                        />
                        <path
                          d="M27.1875 1.4375H21.5625V5.1875H27.1875V1.4375Z"
                          fill="#E7FF60"
                        />
                        <path
                          d="M20.625 20.1875H4.6875V33.3125H20.625V20.1875Z"
                          fill="#7FEBE9"
                        />
                        <path
                          d="M28.125 18.3125V19.25L27.1875 5.1875H21.5625L19.6875 33.3125H28.125H29.0625H54.375V18.3125H28.125Z"
                          fill="#05A9A6"
                        />
                        <path
                          d="M38.4375 14.5625L39.375 5.1875H43.125L44.0625 14.5625"
                          fill="#3AFF08"
                        />
                        <path
                          d="M46.875 14.5625L47.8125 5.1875H51.5625L52.5 14.5625"
                          fill="#3AFF08"
                        />
                        <path
                          d="M30 14.5625L30.9375 5.1875H34.6875L35.625 14.5625"
                          fill="#3AFF08"
                        />
                        <path
                          d="M52.5 14.5625H30C28.4467 14.5625 27.1875 15.8217 27.1875 17.375C27.1875 18.9283 28.4467 20.1875 30 20.1875H52.5C54.0533 20.1875 55.3125 18.9283 55.3125 17.375C55.3125 15.8217 54.0533 14.5625 52.5 14.5625Z"
                          fill="#7FEBE9"
                        />
                        <path
                          d="M58.125 32.375H1.875V34.25H58.125V32.375Z"
                          fill="#3AFF08"
                        />
                        <path
                          d="M6.5625 20.1875L7.5 10.8125H11.25L12.1875 20.1875"
                          fill="#3AFF08"
                        />
                        <path
                          d="M35.625 23.9375H31.875V29.5625H35.625V23.9375Z"
                          fill="#E7FF60"
                        />
                        <path
                          d="M50.625 23.9375H46.875V29.5625H50.625V23.9375Z"
                          fill="#E7FF60"
                        />
                        <path
                          d="M43.125 23.9375H39.375V29.5625H43.125V23.9375Z"
                          fill="#E7FF60"
                        />
                        <path
                          d="M9.375 23H7.5V24.875H9.375V23Z"
                          fill="#E7FF60"
                        />
                        <path
                          d="M13.125 23H11.25V24.875H13.125V23Z"
                          fill="#E7FF60"
                        />
                        <path
                          d="M16.875 23H15V24.875H16.875V23Z"
                          fill="#E7FF60"
                        />
                        <path
                          d="M9.375 26.75H7.5V28.625H9.375V26.75Z"
                          fill="#E7FF60"
                        />
                        <path
                          d="M13.125 26.75H11.25V28.625H13.125V26.75Z"
                          fill="#E7FF60"
                        />
                        <path
                          d="M16.875 26.75H15V28.625H16.875V26.75Z"
                          fill="#E7FF60"
                        />
                        <path
                          d="M30 58.625C31.0355 58.625 31.875 57.7855 31.875 56.75C31.875 55.7145 31.0355 54.875 30 54.875C28.9645 54.875 28.125 55.7145 28.125 56.75C28.125 57.7855 28.9645 58.625 30 58.625Z"
                          fill="#65C8D0"
                        />
                        <path
                          d="M56.25 58.625C57.2855 58.625 58.125 57.7855 58.125 56.75C58.125 55.7145 57.2855 54.875 56.25 54.875C55.2145 54.875 54.375 55.7145 54.375 56.75C54.375 57.7855 55.2145 58.625 56.25 58.625Z"
                          fill="#65C8D0"
                        />
                        <path
                          d="M52.5 51.125C53.5355 51.125 54.375 50.2855 54.375 49.25C54.375 48.2145 53.5355 47.375 52.5 47.375C51.4645 47.375 50.625 48.2145 50.625 49.25C50.625 50.2855 51.4645 51.125 52.5 51.125Z"
                          fill="#65C8D0"
                        />
                        <path
                          d="M56.25 43.625C57.2855 43.625 58.125 42.7855 58.125 41.75C58.125 40.7145 57.2855 39.875 56.25 39.875C55.2145 39.875 54.375 40.7145 54.375 41.75C54.375 42.7855 55.2145 43.625 56.25 43.625Z"
                          fill="#65C8D0"
                        />
                        <path
                          d="M3.75 58.625C4.78553 58.625 5.625 57.7855 5.625 56.75C5.625 55.7145 4.78553 54.875 3.75 54.875C2.71447 54.875 1.875 55.7145 1.875 56.75C1.875 57.7855 2.71447 58.625 3.75 58.625Z"
                          fill="#65C8D0"
                        />
                        <path
                          d="M7.5 51.125C8.53553 51.125 9.375 50.2855 9.375 49.25C9.375 48.2145 8.53553 47.375 7.5 47.375C6.46447 47.375 5.625 48.2145 5.625 49.25C5.625 50.2855 6.46447 51.125 7.5 51.125Z"
                          fill="#65C8D0"
                        />
                        <path
                          d="M3.75 43.625C4.78553 43.625 5.625 42.7855 5.625 41.75C5.625 40.7145 4.78553 39.875 3.75 39.875C2.71447 39.875 1.875 40.7145 1.875 41.75C1.875 42.7855 2.71447 43.625 3.75 43.625Z"
                          fill="#65C8D0"
                        />
                        <path
                          d="M56.2501 53.9375C55.6698 53.9391 55.1043 54.1202 54.631 54.4559C54.1577 54.7916 53.7998 55.2654 53.6063 55.8125H44.0626V52.0625C44.0643 51.8322 43.9811 51.6093 43.8289 51.4364C43.6767 51.2635 43.4663 51.1526 43.2376 51.125L36.5626 50.3V47.7219C37.8546 47.0874 39.0482 46.2696 40.1063 45.2937L40.3126 46.5875C40.3485 46.8093 40.463 47.0109 40.635 47.1554C40.8071 47.3 41.0254 47.3779 41.2501 47.375H43.6782L46.2095 49.9156C46.2971 50.0025 46.401 50.0713 46.5152 50.1179C46.6294 50.1646 46.7517 50.1882 46.8751 50.1875H49.8563C50.0775 50.813 50.5126 51.3402 51.0849 51.6759C51.6572 52.0116 52.3297 52.1342 52.9836 52.022C53.6375 51.9098 54.2307 51.5701 54.6583 51.0628C55.0859 50.5556 55.3205 49.9135 55.3205 49.25C55.3205 48.5865 55.0859 47.9444 54.6583 47.4372C54.2307 46.9299 53.6375 46.5902 52.9836 46.478C52.3297 46.3658 51.6572 46.4884 51.0849 46.8241C50.5126 47.1598 50.0775 47.687 49.8563 48.3125H47.2595L44.7282 45.7719C44.6406 45.685 44.5367 45.6162 44.4225 45.5696C44.3083 45.5229 44.186 45.4993 44.0626 45.5H42.047L41.7282 43.5687C42.6211 42.4461 43.3502 41.2025 43.8938 39.875H47.1376L47.8595 42.05C47.9224 42.2362 48.0422 42.3979 48.202 42.5123C48.3618 42.6267 48.5535 42.688 48.7501 42.6875H53.6063C53.8275 43.313 54.2626 43.8402 54.8349 44.1759C55.4072 44.5116 56.0797 44.6342 56.7336 44.522C57.3875 44.4098 57.9807 44.0701 58.4083 43.5628C58.8359 43.0556 59.0705 42.4135 59.0705 41.75C59.0705 41.0865 58.8359 40.4444 58.4083 39.9372C57.9807 39.4299 57.3875 39.0902 56.7336 38.978C56.0797 38.8658 55.4072 38.9884 54.8349 39.3241C54.2626 39.6598 53.8275 40.187 53.6063 40.8125H49.4251L48.7501 38.6375C48.6849 38.4435 48.5579 38.2761 48.3886 38.161C48.2193 38.0459 48.017 37.9893 47.8126 38H44.5032C44.8309 36.7769 44.9979 35.5163 45.0001 34.25H43.1251C43.1251 37.731 41.7423 41.0694 39.2809 43.5308C36.8194 45.9922 33.4811 47.375 30.0001 47.375C26.5191 47.375 23.1807 45.9922 20.7193 43.5308C18.2579 41.0694 16.8751 37.731 16.8751 34.25H15.0001C15.0023 35.5163 15.1693 36.7769 15.497 38H12.1876C11.991 37.9995 11.7993 38.0608 11.6395 38.1752C11.4797 38.2896 11.3599 38.4513 11.297 38.6375L10.5751 40.8125H6.39384C6.17269 40.187 5.73752 39.6598 5.16526 39.3241C4.593 38.9884 3.92049 38.8658 3.26659 38.978C2.61269 39.0902 2.0195 39.4299 1.59186 39.9372C1.16423 40.4444 0.929687 41.0865 0.929688 41.75C0.929687 42.4135 1.16423 43.0556 1.59186 43.5628C2.0195 44.0701 2.61269 44.4098 3.26659 44.522C3.92049 44.6342 4.593 44.5116 5.16526 44.1759C5.73752 43.8402 6.17269 43.313 6.39384 42.6875H11.2501C11.4466 42.688 11.6384 42.6267 11.7982 42.5123C11.958 42.3979 12.0778 42.2362 12.1407 42.05L12.8626 39.875H16.1063C16.6422 41.2236 17.3717 42.4869 18.272 43.625L17.9532 45.5H15.9376C15.8142 45.4993 15.6919 45.5229 15.5777 45.5696C15.4635 45.6162 15.3596 45.685 15.272 45.7719L12.7407 48.3125H10.1438C9.92268 47.687 9.48752 47.1598 8.91526 46.8241C8.343 46.4884 7.67049 46.3658 7.01659 46.478C6.36269 46.5902 5.7695 46.9299 5.34186 47.4372C4.91423 47.9444 4.67969 48.5865 4.67969 49.25C4.67969 49.9135 4.91423 50.5556 5.34186 51.0628C5.7695 51.5701 6.36269 51.9098 7.01659 52.022C7.67049 52.1342 8.343 52.0116 8.91526 51.6759C9.48752 51.3402 9.92268 50.813 10.1438 50.1875H13.1251C13.2485 50.1882 13.3708 50.1646 13.485 50.1179C13.5992 50.0713 13.7031 50.0025 13.7907 49.9156L16.322 47.375H18.7501C18.9748 47.3779 19.1931 47.3 19.3651 47.1554C19.5372 47.0109 19.6516 46.8093 19.6876 46.5875L19.8938 45.2937C20.9517 46.2699 22.1454 47.0877 23.4376 47.7219V50.3L16.7626 51.125C16.5339 51.1526 16.3234 51.2635 16.1713 51.4364C16.0191 51.6093 15.9359 51.8322 15.9376 52.0625V55.8125H6.39384C6.17269 55.187 5.73752 54.6598 5.16526 54.3241C4.593 53.9884 3.92049 53.8658 3.26659 53.978C2.61269 54.0902 2.0195 54.4299 1.59186 54.9372C1.16423 55.4444 0.929687 56.0865 0.929688 56.75C0.929688 57.4135 1.16423 58.0556 1.59186 58.5628C2.0195 59.0701 2.61269 59.4098 3.26659 59.522C3.92049 59.6342 4.593 59.5116 5.16526 59.1759C5.73752 58.8402 6.17269 58.313 6.39384 57.6875H16.8751C17.1237 57.6875 17.3622 57.5887 17.538 57.4129C17.7138 57.2371 17.8126 56.9986 17.8126 56.75V52.8875L24.4876 52.0625C24.7163 52.0349 24.9267 51.924 25.0789 51.7511C25.2311 51.5782 25.3143 51.3553 25.3126 51.125V48.4906C26.525 48.9028 27.7853 49.158 29.0626 49.25V54.1531C28.4371 54.3743 27.9099 54.8094 27.5742 55.3817C27.2385 55.954 27.1159 56.6265 27.2281 57.2804C27.3403 57.9343 27.68 58.5275 28.1873 58.9551C28.6945 59.3827 29.3366 59.6173 30.0001 59.6173C30.6635 59.6173 31.3056 59.3827 31.8129 58.9551C32.3201 58.5275 32.6599 57.9343 32.7721 57.2804C32.8843 56.6265 32.7617 55.954 32.426 55.3817C32.0903 54.8094 31.5631 54.3743 30.9376 54.1531V49.25C32.2128 49.1732 33.473 48.9337 34.6876 48.5375V51.125C34.6859 51.3553 34.7691 51.5782 34.9213 51.7511C35.0734 51.924 35.2839 52.0349 35.5126 52.0625L42.1876 52.8969V56.75C42.1876 56.9986 42.2864 57.2371 42.4622 57.4129C42.638 57.5887 42.8764 57.6875 43.1251 57.6875H53.6063C53.7783 58.1739 54.0808 58.6037 54.4807 58.9298C54.8806 59.2558 55.3624 59.4656 55.8736 59.5361C56.3847 59.6066 56.9053 59.5352 57.3786 59.3296C57.8518 59.124 58.2594 58.7923 58.5567 58.3706C58.854 57.9489 59.0295 57.4535 59.0641 56.9387C59.0988 56.4239 58.9911 55.9095 58.753 55.4518C58.5148 54.9941 58.1553 54.6107 57.7139 54.3437C57.2725 54.0766 56.766 53.9361 56.2501 53.9375ZM52.5001 48.3125C52.6855 48.3125 52.8668 48.3675 53.0209 48.4705C53.1751 48.5735 53.2953 48.7199 53.3662 48.8912C53.4372 49.0625 53.4557 49.251 53.4196 49.4329C53.3834 49.6148 53.2941 49.7818 53.163 49.9129C53.0319 50.044 52.8648 50.1333 52.683 50.1695C52.5011 50.2057 52.3126 50.1871 52.1413 50.1161C51.97 50.0452 51.8236 49.925 51.7206 49.7708C51.6176 49.6167 51.5626 49.4354 51.5626 49.25C51.5626 49.0014 51.6614 48.7629 51.8372 48.5871C52.013 48.4113 52.2514 48.3125 52.5001 48.3125ZM56.2501 40.8125C56.4355 40.8125 56.6168 40.8675 56.7709 40.9705C56.9251 41.0735 57.0453 41.2199 57.1162 41.3912C57.1872 41.5625 57.2057 41.751 57.1696 41.9329C57.1334 42.1148 57.0441 42.2818 56.913 42.4129C56.7819 42.544 56.6148 42.6333 56.433 42.6695C56.2511 42.7057 56.0626 42.6871 55.8913 42.6161C55.72 42.5452 55.5736 42.425 55.4706 42.2708C55.3676 42.1167 55.3126 41.9354 55.3126 41.75C55.3126 41.5014 55.4114 41.2629 55.5872 41.0871C55.763 40.9113 56.0014 40.8125 56.2501 40.8125ZM3.75009 42.6875C3.56467 42.6875 3.38341 42.6325 3.22924 42.5295C3.07507 42.4265 2.95491 42.2801 2.88395 42.1088C2.81299 41.9375 2.79443 41.749 2.8306 41.5671C2.86678 41.3852 2.95606 41.2182 3.08718 41.0871C3.21829 40.956 3.38533 40.8667 3.56719 40.8305C3.74905 40.7943 3.93755 40.8129 4.10885 40.8839C4.28016 40.9548 4.42658 41.075 4.52959 41.2292C4.6326 41.3833 4.68759 41.5646 4.68759 41.75C4.68759 41.9986 4.58882 42.2371 4.413 42.4129C4.23719 42.5887 3.99873 42.6875 3.75009 42.6875ZM7.50009 50.1875C7.31467 50.1875 7.13341 50.1325 6.97924 50.0295C6.82507 49.9265 6.70491 49.7801 6.63395 49.6088C6.56299 49.4375 6.54443 49.249 6.5806 49.0671C6.61678 48.8852 6.70606 48.7182 6.83718 48.5871C6.96829 48.456 7.13533 48.3667 7.31719 48.3305C7.49905 48.2943 7.68755 48.3129 7.85885 48.3839C8.03016 48.4548 8.17658 48.575 8.27959 48.7292C8.3826 48.8833 8.43759 49.0646 8.43759 49.25C8.43759 49.4986 8.33882 49.7371 8.163 49.9129C7.98719 50.0887 7.74873 50.1875 7.50009 50.1875ZM3.75009 57.6875C3.56467 57.6875 3.38341 57.6325 3.22924 57.5295C3.07507 57.4265 2.95491 57.2801 2.88395 57.1088C2.81299 56.9375 2.79443 56.749 2.8306 56.5671C2.86678 56.3852 2.95606 56.2182 3.08718 56.0871C3.21829 55.956 3.38533 55.8667 3.56719 55.8305C3.74905 55.7943 3.93755 55.8129 4.10885 55.8839C4.28016 55.9548 4.42658 56.075 4.52959 56.2292C4.6326 56.3833 4.68759 56.5646 4.68759 56.75C4.68759 56.9986 4.58882 57.2371 4.413 57.4129C4.23719 57.5887 3.99873 57.6875 3.75009 57.6875ZM30.0001 57.6875C29.8147 57.6875 29.6334 57.6325 29.4792 57.5295C29.3251 57.4265 29.2049 57.2801 29.134 57.1088C29.063 56.9375 29.0444 56.749 29.0806 56.5671C29.1168 56.3852 29.2061 56.2182 29.3372 56.0871C29.4683 55.956 29.6353 55.8667 29.8172 55.8305C29.999 55.7943 30.1875 55.8129 30.3589 55.8839C30.5302 55.9548 30.6766 56.075 30.7796 56.2292C30.8826 56.3833 30.9376 56.5646 30.9376 56.75C30.9376 56.9986 30.8388 57.2371 30.663 57.4129C30.4872 57.5887 30.2487 57.6875 30.0001 57.6875ZM56.2501 57.6875C56.0647 57.6875 55.8834 57.6325 55.7292 57.5295C55.5751 57.4265 55.4549 57.2801 55.384 57.1088C55.313 56.9375 55.2944 56.749 55.3306 56.5671C55.3668 56.3852 55.4561 56.2182 55.5872 56.0871C55.7183 55.956 55.8853 55.8667 56.0672 55.8305C56.249 55.7943 56.4375 55.8129 56.6089 55.8839C56.7802 55.9548 56.9266 56.075 57.0296 56.2292C57.1326 56.3833 57.1876 56.5646 57.1876 56.75C57.1876 56.9986 57.0888 57.2371 56.913 57.4129C56.7372 57.5887 56.4987 57.6875 56.2501 57.6875Z"
                          fill="#05A9A6"
                        />
                      </svg>
                    </span>
                    <span className="txt">Digital Transformation</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cta">
        <div className="cta-flex" onClick={handleShowContact}>
          <h4>Let's Get In Touch</h4>
          <svg
            width="46"
            height="47"
            viewBox="0 0 46 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.417 33.0834L32.5837 13.9167M32.5837 13.9167H15.3337M32.5837 13.9167V31.1668"
              stroke="#15ADAA"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default Retail;
